import Header from "./components/Header/Header";
import Lesson from "./pages/Lesson";

function App() {
  return (
    <div className="App">
      <Header/>
      <Lesson/>
    </div>
  );
}

export default App;
